// @ts-nocheck

import { useLayoutEffect } from 'react';

/**
 * custom hook which locks the scroll when we need it
 * @see https://usehooks.com/useLockBodyScroll/
 *
 * @param {any} scrollElement the target element where the lock will be applied
 * @param {boolean} isDisabled disable or not the lock mecanism
 */
const useLockBodyScroll = (scrollElement: unknown = document.body, isDisabled: boolean = false) => {
  useLayoutEffect(() => {
    let originalStyle = null;
    if (!isDisabled) {
      // Get original body overflow
      originalStyle = window.getComputedStyle(scrollElement).overflow;
      // Prevent scrolling on mount
      scrollElement.style.overflow = 'hidden';
    }
    // Re-enable scrolling when component unmounts
    return () => {
      if (!isDisabled && originalStyle !== null) {
        scrollElement.style.overflow = originalStyle;
      }
    };
  }, [isDisabled, scrollElement]);
};

export default useLockBodyScroll;
